import { user, position, organization } from "../redux/reducers";

/**
 * 获取ID
 */
export const getId = function () {
  return getUser().id;
};

/**
 * 获取姓名
 */
export const getName = function () {
  return getUser().name;
};

/**
 * 获取用户账号
 */
export const getUsername = function () {
  return getUser().username;
};

/**
 * 获取用户
 */
export const getUser = function () {
  return { ...user.state.userInfo };
};

/**
 * 获取岗位
 */
export const getPosition = function () {
  return { ...position.state.position };
};

/**
 * 获取机构
 */
export const getOrganization = function () {
  return { ...organization.state.organization };
};
